const parseJson = async response => {
    const text = await response.text()
    try{
      const json = JSON.parse(text)
      return json
    } catch(err) {
      throw new Error("Did not receive JSON, instead received: " + text)
    }
}

export const customFetch = (url: string, options?: RequestInit) => {
    return fetch(url, options)
        .then(parseJson)
}

export const fetchConstantJSONValues = async () => {
  const result =  await customFetch('/api/setting/constantsJsonValues')
  
  return result
}